module.exports = __webpack_public_path__ + "static/img/urbanDeveloper.592c467d.png";